import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pending-orders-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content position-relative" }
const _hoisted_4 = { class: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block" }, " Pending Orders ", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "113", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "trezo-badge rejected" }, " -3.2% ", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs d-block" }, " vs previous 30 days ", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "area",
                height: "125",
                options: _ctx.pendingOrders,
                series: _ctx.orders
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}